import { DanceEventTimePhaseEnum } from '../../..';

export class GetDanceEventQueryDto {
  danceSchoolId: string;
  timePhase: DanceEventTimePhaseEnum;
}
